/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: eligibility.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateEligibilityCheckRequest,
  CreateEligibilityCheckResponse,
  GetCaseRecordEligibilityChecksRequest,
  GetCaseRecordEligibilityChecksResponse,
  GetEligibilityCheckRequest,
  GetEligibilityCheckResponse,
  UpdateEligibilityCheckRequest,
  UpdateEligibilityCheckResponse,
} from '../types/eligibility';

export const createEligibilityService = (transport: Transport) => ({
  async createEligibilityCheck(
    request: CreateEligibilityCheckRequest,
    options: RequestOptions = {},
  ): Promise<CreateEligibilityCheckResponse> {
    const { organization_id, program_id, caserecord_id, ...body } = request;
    const url = getApiPath(API_METHODS.EligibilityCheckService.CreateEligibilityCheck, {
      organization_id,
      program_id,
      caserecord_id,
    });
    return transport.post<CreateEligibilityCheckResponse>(url, body, options);
  },

  async getEligibilityCheck(
    request: GetEligibilityCheckRequest,
    options: RequestOptions = {},
  ): Promise<GetEligibilityCheckResponse> {
    const { organization_id, program_id, caserecord_id, eligibility_check_id } = request;
    const url = getApiPath(API_METHODS.EligibilityCheckService.GetEligibilityCheck, {
      organization_id,
      program_id,
      caserecord_id,
      eligibility_check_id,
    });
    return transport.get<GetEligibilityCheckResponse>(url, options);
  },

  async updateEligibilityCheck(
    request: UpdateEligibilityCheckRequest,
    options: RequestOptions = {},
  ): Promise<UpdateEligibilityCheckResponse> {
    const { organization_id, program_id, caserecord_id, eligibility_check_id, ...body } = request;
    const url = getApiPath(API_METHODS.EligibilityCheckService.UpdateEligibilityCheck, {
      organization_id,
      program_id,
      caserecord_id,
      eligibility_check_id,
    });
    return transport.post<UpdateEligibilityCheckResponse>(url, body, options);
  },

  async getCaseRecordEligibilityChecks(
    request: GetCaseRecordEligibilityChecksRequest,
    options: RequestOptions = {},
  ): Promise<GetCaseRecordEligibilityChecksResponse> {
    const { organization_id, program_id, caserecord_id, ...params } = request;
    const url = getApiPath(API_METHODS.EligibilityCheckService.GetCaseRecordEligibilityChecks, {
      organization_id,
      program_id,
      caserecord_id,
    });
    return transport.get<GetCaseRecordEligibilityChecksResponse>(url, { params, ...options });
  },
});

export type EligibilityService = ReturnType<typeof createEligibilityService>;
